import { render, staticRenderFns } from "./SingleOrdersModal.vue?vue&type=template&id=358ced9e&scoped=true&"
import script from "./SingleOrdersModal.vue?vue&type=script&lang=js&"
export * from "./SingleOrdersModal.vue?vue&type=script&lang=js&"
import style0 from "./SingleOrdersModal.vue?vue&type=style&index=0&id=358ced9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358ced9e",
  null
  
)

component.options.__file = "SingleOrdersModal.vue"
export default component.exports